<header class="admin-header">

  <div class="header-inner">

    <!-- LEFT -->
    <div class="header-left">
      <span class="logo">
        <span class="logo-daily">Daily</span
        ><span class="logo-city">City</span>
      </span>
      <span class="admin-badge">Admin</span>
    </div>

    <!-- RIGHT -->
    <div class="header-right">
      <button class="logout-btn" (click)="logout()">Logout</button>
    </div>

  </div>

</header>
